import { render, staticRenderFns } from "./Ebooks.vue?vue&type=template&id=99a7c8ac&scoped=true&"
import script from "./Ebooks.vue?vue&type=script&lang=js&"
export * from "./Ebooks.vue?vue&type=script&lang=js&"
import style0 from "./Ebooks.vue?vue&type=style&index=0&id=99a7c8ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a7c8ac",
  null
  
)

export default component.exports